<template>
  <div>
    <v-row>
      <v-card class="width-100 mt-4">
        <v-toolbar flat class="indigo lighten-5">
          <v-text-field
            solo
            flat
            dense
            label="Search"
            style="max-width: 280px"
            hide-details
            v-model="search"
            :class="[search && !filteredUsers.length ? 'search-no-results' : 'search']"
          >
            <template v-slot:prepend-inner>
              <v-icon>mdi-magnify</v-icon>
            </template>
            <template v-slot:append v-if="search">
              <v-btn small icon class="mr-n1" @click="search = ''">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-text-field>

          <input type="text" style="opacity: 0; width: 10px" id="pass" :value="pass">

          <v-spacer></v-spacer>

          <span class="caption mx-1 hidden-sm-and-down">Rows per page</span>
          <div style="max-width: 60px" class="mx-3">
            <v-select
              v-model="pageSize"
              :items="[20, 50, 100]"
              dense
              hide-details
            ></v-select>
          </div>
        </v-toolbar>

        <v-simple-table>
          <template v-slot:default>
            <thead v-if="filteredUsers.length">
              <tr class="indigo-lighten-6">
                <th></th>
                <th
                  @click="setSortType('name')"
                  class="th-user-name th-clickable"
                >Name</th>
                <th
                  @click="setSortType('email')"
                  class="th-clickable"
                >Email</th>
                <th
                  @click="setSortType('award')"
                  class="th-award-name th-clickable"
                >Award</th>
                <th
                  @click="setSortType('user')"
                  class="th-clickable"
                >Role</th>
                <th>Password</th>
                <th
                  @click="setSortType('claimed')"
                  class="th-clickable"
                >Register Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, $index) in paginatedUsers"
                :key="$index"
                @click="goToUser(item)"
                class="blue-grey--text text--darken-3 tr-user"
              >
                <td class="py-1 td-avatar">
                  <img
                    v-if="item.user && item.user.image"
                    :src="`${baseURL}/img/users/64/${item.user.image}`"
                  >
                  <v-avatar v-else-if="item.user" color="blue-grey lighten-5">
                    <span class="blue-grey--text text--darken-1">
                      {{ item.user | fullName | capitalizeName }}
                    </span>
                  </v-avatar>
                  <v-avatar v-else color="blue-grey lighten-5">
                    <v-icon class="blue-grey--text text--lighten-2">mdi-account-circle</v-icon>
                  </v-avatar>
                </td>
                <td>
                  <span v-if="item.user">{{ item.user | fullName }}</span>
                </td>
                <td>{{ item.email }}</td>
                <td>
                  <span v-if="item.award">{{ item.award.name }}</span>
                </td>
                <td>
                  <span v-if="item.user">{{ item.user.role }}</span>
                </td>
                <td class="text-center">
                  <div v-if="item.user && item.user.pass">
                    <v-tooltip
                      top
                      :open-on-hover="false"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn icon @click="on.click" @blur="on.blur" retain-focus-on-click>
                          <v-icon class="text-subtitle">mdi-eye-outline</v-icon>
                        </v-btn>
                      </template>
                      <span style="pointer-events: initial;">
                        {{ item.user.pass }}<br>
                        <div
                          class="text-center"
                        >
                          <v-btn
                            x-small
                            @click="copyPass(item.user.pass)"
                          >Copy</v-btn>
                        </div>
                      </span>
                    </v-tooltip>
                  </div>
                </td>
                <td>
                  {{ moment(item.claimed).format('L') }}
                </td>
                <td>
                  <v-btn
                    @click.stop="callConfirmDeleteUserDialog(item)"
                    icon
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>

      <div v-if="!filteredUsers.length" class="mx-4 my-6 grey--text text--darken-1 text-center width-100">
        No matching <span class="font-weight-medium">Users</span> found in the database
      </div>
    </v-row>

    <v-row justify="center" v-if="filteredUsers.length">
      <v-col cols="8">
        <v-container>
          <v-pagination
            v-model="pageNumber"
            :length="pagesQty"
          ></v-pagination>
        </v-container>
      </v-col>
    </v-row>

    <!-- Confirm Delete User Dialog-->
    <confirm-delete-user-dialog
      ref="confirmDeleteUserDialog"
      :user="inviteToDelete.user"
    ></confirm-delete-user-dialog>

  </div>
</template>

<script>
import ConfirmDeleteUserDialog from '@/components/users/ConfirmDeleteUserDialog.vue'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'ActiveUsers',

  mixins: [messagesMixin],

  props: [
    'users'
  ],

  components: {
    ConfirmDeleteUserDialog
  },

  data () {
    return {
      inviteToDelete: {
        user: {}
      },
      pageNumber: 1,
      pageSize: 20,
      pass: '',
      search: '',
      sortAsc: true,
      sortType: 'name'
    }
  },

  computed: {
    filteredUsers () {
      const search = this.search ? this.search.toLowerCase() : ''

      const users = this.users.filter(item => {
        return (item.user.first_name + ' ' + item.user.last_name).toLowerCase().includes(search) || item.email.toLowerCase().includes(search)
      })

      if (this.sortType === 'name') {
        this.sortByName(users)
      } else if (this.sortType === 'award' || this.sortType === 'user') {
        this.sortByChild(users)
      } else if (this.sortType === 'email' || this.sortType === 'claimed') {
        this.sortBy(users)
      }

      return users
    },

    pagesQty () {
      return this.filteredUsers.length % this.pageSize > 0 ? parseInt(this.filteredUsers.length / this.pageSize) + 1 : parseInt(this.filteredUsers.length / this.pageSize)
    },

    paginatedUsers () {
      return this.filteredUsers.slice((this.pageNumber - 1) * this.pageSize, this.pageNumber * this.pageSize)
    }
  },

  methods: {
    callConfirmDeleteUserDialog (item) {
      this.inviteToDelete = item

      this.$refs.confirmDeleteUserDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.deleteInvite()
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    copyPass (pass) {
      this.pass = pass

      setTimeout(() => {
        const passToCopy = document.querySelector('#pass')
        passToCopy.setAttribute('type', 'text')
        passToCopy.select()

        document.execCommand('copy')

        this.showSuccessMessage('Password was copied!')
      }, 0)
    },

    deleteInvite () {
      this.$http.delete('/invites/' + this.inviteToDelete.id)
        .then(({ data }) => {
          this.$emit('deleteInviteFromList', this.inviteToDelete.id)

          this.showSuccessMessage('User was deleted successfully!')
        })
        .catch(error => {
          console.log(error)
        })
    },

    goToUser (item) {
      if (item.user) {
        this.$router.push({ name: 'users.edit', params: { id: item.id } })
      }
    },

    setSortType (val) {
      this.sortAsc = !this.sortAsc
      this.sortType = val
    },

    sortBy (users) {
      users.sort((a, b) => {
        const nameA = a[this.sortType] ? a[this.sortType].toUpperCase() : ''
        const nameB = b[this.sortType] ? b[this.sortType].toUpperCase() : ''
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByChild (users) {
      const child = this.sortType === 'award' ? 'name' : 'role'

      users.sort((a, b) => {
        const nameA = a[this.sortType] ? a[this.sortType][child].toUpperCase() : ''
        const nameB = b[this.sortType] ? b[this.sortType][child].toUpperCase() : ''
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByName (users) {
      users.sort((a, b) => {
        const firstNameA = a.user.first_name ? a.user.first_name.toUpperCase() : ''
        const lastNameA = a.user.last_name ? a.user.last_name.toUpperCase() : ''
        const firstNameB = b.user.first_name ? b.user.first_name.toUpperCase() : ''
        const lastNameB = b.user.last_name ? b.user.last_name.toUpperCase() : ''

        const nameA = firstNameA + ' ' + lastNameA
        const nameB = firstNameB + ' ' + lastNameB
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })

      return users
    }
  }
}
</script>

<style lang="css" scoped>
  .tr-user:hover {
    cursor: pointer;
  }

  .th-clickable:hover {
    background-color: #eceff1;
    cursor: pointer;
  }

  .th-award-name,
  .th-user-name {
    min-width: 200px;
  }

  .td-avatar {
    text-align: center;
  }

  .td-avatar img {
    max-height: 48px;
    max-width: 48px;
    vertical-align: middle;
  }

  .search >>> .v-input__slot {
    background: rgba(0,0,0,.06) !important;
  }

  .search-no-results >>> .v-input__slot {
    background: #ffcdd2 !important;
  }
</style>
